import axios from 'axios';
import _ from 'lodash';

import { CONSTANT } from './constant';
import { isAlertExempted, sendSlackAlert } from './slack';

const accessKey = 'accessToken';
const profile = 'userProfile';
const isPasswordUpdateRequired = 'changePassword';
const isSSOLogin = 'isSSOLogin';

export const environments = [
  {
    name: 'dev',
    env: 'https://d37bvvg1fq5zck.cloudfront.net',
    // apiHost: 'https://d19gw23pzxczol.cloudfront.net/api',
    apiHost: 'https://d11vgeaykuuisn.cloudfront.net/api',
    sof2ApiHost: 'https://d1nd2761nfgm51.cloudfront.net/api',
    adtApiHost: 'https://d3qv35y8tvum1q.cloudfront.net',
    iotApiHost: 'https://d11vgeaykuuisn.cloudfront.net',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'b-BSAl1syNlW3UxBxz4uY-QimI5ECYgvytqIoX9LYTE',
      environment: 'dev'
    }
  },
  {
    name: 'qa',
    env: 'https://qa.mysofportal.com',
    // apiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    apiHost: 'https://d2plg8aidb2irm.cloudfront.net/api',
    sof2ApiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    iotApiHost: 'https://d2plg8aidb2irm.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'b-BSAl1syNlW3UxBxz4uY-QimI5ECYgvytqIoX9LYTE',
      environment: 'dev'
    }
  },
  {
    name: 'qa',
    env: 'https://qa.iot.mysofportal.com',
    // apiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    apiHost: 'https://d2plg8aidb2irm.cloudfront.net/api',
    sof2ApiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'b-BSAl1syNlW3UxBxz4uY-QimI5ECYgvytqIoX9LYTE',
      environment: 'dev'
    }
  },
  {
    name: 'prod',
    env: 'https://www.mysofportal.com',
    apiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    sof2ApiHost: 'https://d36u5buucu9rtz.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'b-BSAl1syNlW3UxBxz4uY-QimI5ECYgvytqIoX9LYTE',
      environment: 'master'
    }
  },
  {
    name: 'preview',
    env: 'https://preview.mysofportal.com',
    apiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    sof2ApiHost: 'https://d36u5buucu9rtz.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'YZZkyCkjbk5Xjrnz00Drbe4ZguoR4EqVNFwRfyKgtI0',
      host: 'preview.contentful.com',
      environment: 'master'
    }
  }
];

export const getEnvironment = () => {
  const currentEnvironment = environments.find(
    environment => window.location.origin === environment.env
  );
  return currentEnvironment || environments[0];
};

const getApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getSOF2ApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.sof2ApiHost;
};

const getAdtDashboardApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.adtApiHost;
};

export const apiHost = getApiHost();
export const sof2ApiHost = getSOF2ApiHost();
export const adtApiHost = getAdtDashboardApiHost();

// eslint-disable-next-line camelcase
export const { admin_access_token } = getEnvironment();

export const defectManagementConfig = (method = 'get', url = '') => ({
  method,
  url,
  headers: {
    // eslint-disable-next-line no-undef
    admin_access_token,
    'Access-Control-Allow-Origin': '*'
  }
});

export const config = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(accessKey)}`,
      'Access-Control-Allow-Origin': '*'
    }
  };
};

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const { name: envName } = getEnvironment();
    const userProfile = JSON.parse(localStorage.getItem(profile));
    if (!isAlertExempted(error.response)) {
      sendSlackAlert(
        {
          ...error.response,
          email: _.get(userProfile, 'email', '')
        },
        envName
      );
    }
    if (error.response && error.response.status === 403) {
      localStorage.setItem('isExpired', true);
    } else {
      throw error;
    }
  }
);

const request = {
  setToken: token => {
    localStorage.setItem(accessKey, token);
  },
  setProfile: value => {
    const data = {
      ...value,
      name: `${value.first_name} ${value.last_name}`
    };
    localStorage.setItem(profile, JSON.stringify(data));
  },
  setPasswordUpdate: value => {
    localStorage.setItem(isPasswordUpdateRequired, value);
  },
  setSSOLoginState: value => {
    localStorage.setItem(isSSOLogin, value);
  },
  getToken: () => {
    return localStorage.getItem(accessKey);
  },
  getProfile: () => {
    return JSON.parse(localStorage.getItem(profile));
  },
  getPasswordUpdate: () => {
    return JSON.parse(localStorage.getItem(isPasswordUpdateRequired));
  },
  getSSOLoginState: () => {
    const data = localStorage.getItem(isSSOLogin);
    return data ? JSON.parse(data) : false;
  },
  get: url => {
    return axios.get(`${apiHost}${url}`, config());
  },
  post: (url, body) => {
    return axios.post(`${apiHost}${url}`, body, config());
  },
  put: (url, body) => {
    return axios.put(`${apiHost}${url}`, body, config());
  },
  delete: url => {
    return axios.delete(`${apiHost}${url}`, config());
  }
};

export const USER_RIGHTS = {
  ADMIN: {
    isStatusEditable: true,
    isUserEditable: true,
    canAssignOrder: true,
    isAdminBandVisible: true,
    isUserPageVisible: true,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: true,
    isHomeLinkVisible: true,
    canAddComments: true,
    canPerformAction: true,
    isDefectManagementVisible: true
  },
  SALES_REP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: false,
    isHomeLinkVisible: true,
    canAddComments: true,
    canPerformAction: false,
    isDefectManagementVisible: false
  },
  ORDER_FULFILLMENT: {
    isStatusEditable: true,
    isUserEditable: false,
    canAssignOrder: true,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: false,
    isHomeLinkVisible: true,
    canAddComments: true,
    canPerformAction: true,
    isDefectManagementVisible: false
  },
  PROPOSAL_HOUSE: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: false,
    isHomeLinkVisible: true,
    canAddComments: false,
    canPerformAction: false,
    isDefectManagementVisible: false
  },
  SALES_MANAGER: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: false,
    isHomeLinkVisible: true,
    canAddComments: false,
    canPerformAction: false,
    isDefectManagementVisible: false
  },
  SALES_SUPPORT: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isQuoteApprovalDashboardVisible: false,
    isBulkUploadVisible: false,
    isHomeLinkVisible: true,
    canAddComments: false,
    canPerformAction: false,
    isDefectManagementVisible: false
  }
};

export const isAdmin =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.ADMIN;

export const isSalesRep =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.SALES_REP;

export const isOrderFulfillmentTeam =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.ORDER_FULFILLMENT;

export const isSalesManager =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.SALES_MANAGER;

export const isProposalHouse =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.PROPOSAL_HOUSE;

export const isSalesSupport =
  request.getProfile() &&
  request.getProfile().role.name === CONSTANT.KEYS.ROLES.SALES_SUPPORT;

export default request;
